export default __webpack_public_path__ + "static/media/Group 3185.31e7617f.svg";